import { render, staticRenderFns } from "./UserQueue.vue?vue&type=template&id=4a52d857"
import script from "./UserQueue.vue?vue&type=script&lang=js"
export * from "./UserQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports